if (!customElements.get('juronoid-faq')) {
  customElements.define('juronoid-faq', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const input = this.querySelector('[data-faq-input]');
      const items = [...this.querySelectorAll('[data-faq-item]')];
      const count = this.querySelector('[data-faq-count]');
      const normalise = value => value.toLocaleLowerCase('de').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      const update = () => {
        const words = normalise(input.value.trim()).split(/\s+/).filter(Boolean);
        let visible = 0;
        items.forEach(item => {
          const match = words.every(word => normalise(item.textContent).includes(word));
          item.hidden = !match;
          if (match) visible++;
        });
        count.textContent = `${visible} ${count.dataset.label}`;
        this.querySelector('[data-faq-empty]').hidden = visible > 0;
      };
      this.querySelector('[data-faq-controls]').hidden = false;
      input.addEventListener('input', update, {signal:this.abort.signal});
      this.querySelector('[data-faq-reset]').addEventListener('click', () => {input.value = ''; update(); input.focus();}, {signal:this.abort.signal});
      update();
    }
    disconnectedCallback() {this.abort?.abort(); this.abort = null;}
  });
}
